export const ROLE_SCOPES = {
  SYSTEM: "system",
  TENANT: "tenant",
};
